module.exports = __webpack_public_path__ + "static/media/66 - Logo PPI Belanda.3de1a95d.png";